class CollectionFilters {

    elements = {};

    constructor(wrapper) {
        this.loadElements(wrapper);
        this.unhideOptions();
        this.setFilterNameTitles();
        this.setEventListeners();
    }

    loadElements(wrapper) {
        this.elements.wrapper = wrapper;
        this.elements.toggle = wrapper.find('.collection-filters__filter-toggle');
        this.elements.filterName = wrapper.find('.collection-filters__filter-name');
        this.elements.options = wrapper.find('.collection-filters__filter-options');
    }

    unhideOptions() {
        this.elements.options.each(
            (index) => {
                let options = this.elements.options.eq(index);
                let toggleId = options.data('depends-on');
                let hidden = this.elements.toggle.filter('#' + toggleId).filter(':checked').length < 1;

                options.prop('hidden', hidden);
            }
        );
    }

    setFilterNameTitles() {
        this.elements.filterName.each(
            (index) => {
                let filterName = this.elements.filterName.eq(index);
                let toggleId = filterName.attr('for');
                let hidden = this.elements.toggle.filter('#' + toggleId).filter(':checked').length < 1;

                filterName.prop('title', hidden ? filterName.data('default-title') : filterName.data('active-title') );
            }
        );
    }

    setEventListeners() {
        this.elements.toggle.on(
            'change',
            () => {
                this.unhideOptions();
                this.setFilterNameTitles();
            }
        );
    }

};

jQuery('.collection-filters__wrapper').each(
    function() {
        new CollectionFilters(jQuery(this));
    }
);
